"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _ = require("../..");

var _styles = require("../../styles");

var _i18n = require("../i18n");

var _validation = require("./validation");

var _SupportModal = _interopRequireDefault(require("./SupportModal"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _client = require("@apollo/client");

var _createPartnerProfile = _interopRequireDefault(require("./createPartnerProfile.graphql"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var styles = function styles(theme) {
  var _theme$palette, _theme$palette$enterp, _theme$palette2, _theme$palette2$enter, _theme$palette3, _theme$palette3$enter, _theme$palette4, _theme$palette4$enter, _theme$palette5, _theme$palette5$enter;

  return {
    enterpriseAgentForm: {
      padding: theme.spacing(6)
    },
    legalDisclaimerLink: {
      color: (_theme$palette = theme.palette) === null || _theme$palette === void 0 ? void 0 : (_theme$palette$enterp = _theme$palette.enterprise) === null || _theme$palette$enterp === void 0 ? void 0 : _theme$palette$enterp.primary,
      fontSize: theme.spacing(1.5),
      fontWeight: 'bold' // TODO: Need to import the correct weight for pixel perfect match on designs https://earnup.atlassian.net/browse/APPS-1785

    },
    submitBtn: {
      backgroundColor: theme.palette.grey[400],
      '&:hover': {
        backgroundColor: (_theme$palette2 = theme.palette) === null || _theme$palette2 === void 0 ? void 0 : (_theme$palette2$enter = _theme$palette2.enterprise) === null || _theme$palette2$enter === void 0 ? void 0 : _theme$palette2$enter.main,
        color: theme.palette.primary.contrastText
      },
      paddingLeft: theme.spacing(13.125),
      paddingRight: theme.spacing(13.125),
      fontSize: theme.spacing(1.75)
    },
    label: {
      '&$focused': {
        color: (_theme$palette3 = theme.palette) === null || _theme$palette3 === void 0 ? void 0 : (_theme$palette3$enter = _theme$palette3.enterprise) === null || _theme$palette3$enter === void 0 ? void 0 : _theme$palette3$enter.main
      }
    },
    focused: {},
    outlinedInput: {
      '&$focused $notchedOutline': {
        border: "1px solid ".concat((_theme$palette4 = theme.palette) === null || _theme$palette4 === void 0 ? void 0 : (_theme$palette4$enter = _theme$palette4.enterprise) === null || _theme$palette4$enter === void 0 ? void 0 : _theme$palette4$enter.main)
      }
    },
    notchedOutline: {},
    alternateDestinations: {
      fontSize: theme.spacing(1.75),
      color: theme.palette.text.secondary
    },
    divider: {
      width: '100%'
    },
    bottomLinks: {
      color: (_theme$palette5 = theme.palette) === null || _theme$palette5 === void 0 ? void 0 : (_theme$palette5$enter = _theme$palette5.enterprise) === null || _theme$palette5$enter === void 0 ? void 0 : _theme$palette5$enter.main,
      fontWeight: 'bold',
      textDecoration: 'none',
      cursor: 'pointer'
    }
  };
};

exports.styles = styles;
var useStyles = (0, _styles.makeStyles)(styles);

var EnterpriseAgentForm = function EnterpriseAgentForm(_ref) {
  var onSuccess = _ref.onSuccess,
      links = _ref.links,
      client = _ref.client;
  var classes = useStyles();
  var loginPageUrl = "".concat(document.location.protocol).concat(document.location.host, "/login");
  var enterpriseOutlineOverrideProps = {
    InputLabelProps: {
      classes: {
        root: classes.label,
        focused: classes.focused
      }
    },
    InputProps: {
      classes: {
        root: classes.outlinedInput,
        focused: classes.focused,
        notchedOutline: classes.notchedOutline
      }
    }
  };

  var _useMutation = (0, _client.useMutation)(_createPartnerProfile["default"], {
    client: client
  }),
      _useMutation2 = (0, _slicedToArray2["default"])(_useMutation, 2),
      submitSignUpMutation = _useMutation2[0],
      _useMutation2$ = _useMutation2[1],
      loading = _useMutation2$.loading,
      error = _useMutation2$.error;

  var hasError = Boolean(error);

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      supportModalIsOpen = _useState2[0],
      setSupportModalIsOpen = _useState2[1];

  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_.Grid, {
    container: true,
    item: true,
    justifyContent: "center",
    alignContent: "center",
    alignItems: "center",
    xs: 12,
    md: 7,
    className: classes.enterpriseAgentForm
  }, /*#__PURE__*/_react["default"].createElement(_.Grid, {
    item: true
  }, /*#__PURE__*/_react["default"].createElement(_.LoadingGate, {
    condition: !loading
  }, /*#__PURE__*/_react["default"].createElement(_.Form, {
    initialValues: {},
    onSubmit: function onSubmit(values) {
      return submitSignUpMutation({
        variables: {
          input: values
        },
        onCompleted: function onCompleted(data) {
          onSuccess(data.id);
        }
      });
    },
    validationSchema: _validation.enterpriseAgentSignUpValidationSchema
  }, function (props) {
    return /*#__PURE__*/_react["default"].createElement(_.Grid, {
      container: true
    }, /*#__PURE__*/_react["default"].createElement(_.Grid, {
      container: true,
      item: true,
      className: classes.fieldsContainer,
      spacing: 2
    }, /*#__PURE__*/_react["default"].createElement(_.Grid, {
      item: true,
      xs: 12,
      align: "left"
    }, /*#__PURE__*/_react["default"].createElement(_.Typography, {
      variant: "h6",
      Component: "h1"
    }, _i18n.ENTERPRISE_AGENT_FLOW.SIGN_UP_HEADER)), /*#__PURE__*/_react["default"].createElement(_.Grid, {
      item: true,
      xs: 12,
      md: 6
    }, /*#__PURE__*/_react["default"].createElement(_.TextField, (0, _extends2["default"])({
      dataQa: "first-name",
      type: "text",
      label: _i18n.ENTERPRISE_AGENT_FLOW.FORM.FIRST_NAME,
      name: "firstName",
      className: classes.enterpriseInputField
    }, enterpriseOutlineOverrideProps))), /*#__PURE__*/_react["default"].createElement(_.Grid, {
      item: true,
      xs: 12,
      md: 6
    }, /*#__PURE__*/_react["default"].createElement(_.TextField, (0, _extends2["default"])({
      dataQa: "last-name",
      type: "text",
      label: _i18n.ENTERPRISE_AGENT_FLOW.FORM.LAST_NAME,
      name: "lastName",
      className: classes.enterpriseInputField
    }, enterpriseOutlineOverrideProps))), /*#__PURE__*/_react["default"].createElement(_.Grid, {
      item: true,
      xs: 12
    }, /*#__PURE__*/_react["default"].createElement(_.Email, (0, _extends2["default"])({
      dataQa: "work-email",
      label: _i18n.ENTERPRISE_AGENT_FLOW.FORM.WORK_EMAIL,
      name: "email",
      className: classes.enterpriseInputField
    }, enterpriseOutlineOverrideProps))), /*#__PURE__*/_react["default"].createElement(_.Grid, {
      item: true,
      xs: 12
    }, /*#__PURE__*/_react["default"].createElement(_.TextField, (0, _extends2["default"])({
      dataQa: "company-name",
      type: "text",
      label: _i18n.ENTERPRISE_AGENT_FLOW.FORM.COMPANY_NAME,
      name: "companyName",
      className: classes.enterpriseInputField
    }, enterpriseOutlineOverrideProps)))), /*#__PURE__*/_react["default"].createElement(_.Grid, {
      item: true,
      xs: 12,
      align: "left"
    }, /*#__PURE__*/_react["default"].createElement(_.Typography, {
      variant: "caption"
    }, _i18n.ENTERPRISE_AGENT_FLOW.CAVEAT, /*#__PURE__*/_react["default"].createElement(_.Link, {
      dataQa: "consent-link",
      href: links.trustPage,
      className: classes.legalDisclaimerLink,
      target: "_blank"
    }, _i18n.ENTERPRISE_AGENT_FLOW.E_SIGN_CONSENT), ', ', /*#__PURE__*/_react["default"].createElement(_.Link, {
      dataQa: "terms-link",
      href: links.termsOfService,
      className: classes.legalDisclaimerLink,
      target: "_blank"
    }, _i18n.ENTERPRISE_AGENT_FLOW.TERMS_AND_CONDITIONS), ', and ', /*#__PURE__*/_react["default"].createElement(_.Link, {
      dataQa: "privacy-link",
      href: links.privacyPolicy,
      className: classes.legalDisclaimerLink,
      target: "_blank"
    }, _i18n.ENTERPRISE_AGENT_FLOW.PRIVACY_POLICY), '.')), /*#__PURE__*/_react["default"].createElement(_.Grid, {
      item: true,
      xs: 12
    }, /*#__PURE__*/_react["default"].createElement(_.Spacing, {
      marginTop: 5
    }, /*#__PURE__*/_react["default"].createElement(_.SubmitButton, {
      color: "primary",
      dataQa: "signup-form-submit-button",
      className: classes.submitBtn // disabled={Boolean(loading)}

    }, /*#__PURE__*/_react["default"].createElement(_.Typography, {
      dataQa: "signup-form-submit-label",
      variant: "overline"
    }, _i18n.ENTERPRISE_AGENT_FLOW.SIGN_UP_BUTTON)))));
  }))), /*#__PURE__*/_react["default"].createElement(_.Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/_react["default"].createElement(_.Divider, {
    className: classes.divider
  })), /*#__PURE__*/_react["default"].createElement(_.Grid, {
    item: true,
    className: classes.supportLinks
  }, /*#__PURE__*/_react["default"].createElement(_.Grid, {
    container: true,
    justifyContent: "center",
    alignContent: "center"
  }, /*#__PURE__*/_react["default"].createElement(_.Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/_react["default"].createElement(_.Spacing, {
    marginTop: 2
  }, /*#__PURE__*/_react["default"].createElement(_.Typography, {
    variant: "caption",
    className: classes.alternateDestinations
  }, _i18n.ENTERPRISE_AGENT_FLOW.ALREADY_HAVE_ACCOUNT, "\xA0", /*#__PURE__*/_react["default"].createElement(_.Link, {
    className: classes.bottomLinks,
    href: loginPageUrl
  }, _i18n.ENTERPRISE_AGENT_FLOW.LOGIN)))), /*#__PURE__*/_react["default"].createElement(_.Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/_react["default"].createElement(_.Spacing, {
    marginTop: 2
  }, /*#__PURE__*/_react["default"].createElement(_.Typography, {
    variant: "caption",
    className: classes.alternateDestinations
  }, _i18n.ENTERPRISE_AGENT_FLOW.NEED_HELP, "\xA0", /*#__PURE__*/_react["default"].createElement(_.Link, {
    onClick: function onClick() {
      setSupportModalIsOpen(true);
    },
    component: "button",
    className: classes.bottomLinks
  }, _i18n.ENTERPRISE_AGENT_FLOW.SUPPORT)))))), hasError && /*#__PURE__*/_react["default"].createElement(_.Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/_react["default"].createElement(_.Spacing, {
    marginTop: 5
  }, /*#__PURE__*/_react["default"].createElement(_.Alert, {
    severity: "error"
  }, _i18n.ENTERPRISE_AGENT_FLOW.FORM.ERROR)))), /*#__PURE__*/_react["default"].createElement(_SupportModal["default"], {
    isOpen: supportModalIsOpen,
    setIsOpen: setSupportModalIsOpen,
    links: links
  }));
};

EnterpriseAgentForm.propTypes = {
  onSuccess: _propTypes["default"].func.isRequired,
  links: _propTypes["default"].object.isRequired,
  client: _propTypes["default"].object.isRequired
};
var _default = EnterpriseAgentForm;
exports["default"] = _default;